import React, { useEffect } from "react"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import "./AboutPage.scss"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"

const AboutPage = () => {
  useTitle("About Us - The Movie House TV")
  useEffect(() => {
    ReactGA.send("pageview")
  })

  return (
    <TMHBanner classOption="only-gradient policy-page" isLogged={false}>
      <div className="about-page">
        <h1 className="title">About Us</h1>
        <p className="content">
          The Movie House is a streaming content provider that started in 2019.
          With a global user-base, we provide free content to capture the
          interest of customers around the world. Our goal is to always provide
          free content to our users. As we grow, our database of free content
          grows. We are also proud to offer our customer loyalty program where
          you can even watch free New Release movies. Join our cord-cutting
          community – Join The Movie House!
        </p>
        <div className="box">
          <div className="col">
            <b>
              The Movie <br /> House:
            </b>
          </div>
          <div className="col">
            Address <br />{" "}
            <b>1199 S Federal Hwy Suite 245 Boca Raton FI 33432</b>
          </div>
          <div className="col">
            Phone : <br />
            <b> 561 614 4810</b>
          </div>
        </div>
        <nav className="policyPage__footer">
          <a href="/tmh/#/privacy-policy" target="_blank">
            Privacy policy
          </a>
          <a href="/tmh/#/terms-conditions" target="_blank">
            Terms &#38; conditions
          </a>
          <a href="/tmh/#/about" target="_blank">
            About The Movie House
          </a>
        </nav>
      </div>
    </TMHBanner>
  )
}

export default AboutPage
